"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocket = void 0;
const activeAsyncConnection_1 = require("../../../activeAsyncConnection");
class WebSocket {
    constructor(accessToken, request, onResponse, onError, protocols, transformDataFn) {
        this.isCancelled = false;
        this.accessToken = accessToken;
        this.request = request;
        this.onResponse = onResponse;
        this.onError = onError;
        this.protocols = protocols;
        this.transformDataFn = transformDataFn;
        this.webSocket = new activeAsyncConnection_1.WebSocketsV2(`${window.WEBSOCKET_DOMAIN_URL}/?accessToken=${this.accessToken}`, protocols, transformDataFn);
        this.webSocket.listen({
            onReceiveData: (data) => {
                this.onResponse(data);
            },
            onError: (error) => {
                this.onError(error);
            },
        });
    }
    async start() {
        if (!this.isCancelled) {
            try {
                await this.webSocket.connect();
                this.webSocket.send(JSON.stringify(this.request));
            }
            catch (e) {
                this.onError(e);
            }
        }
    }
    async stop() {
        this.isCancelled = true;
        try {
            await this.webSocket.disconnect();
        }
        catch (e) {
            // do nothing
        }
    }
}
exports.WebSocket = WebSocket;
//# sourceMappingURL=webSocket.js.map